import { apiClient, REVIEW_REQUESTS_CHANNELS } from '../../../../shared/api';

export const fetchChannels = async () => {
  const response = await apiClient.get(REVIEW_REQUESTS_CHANNELS);

  return response.data;
};
